import React from 'react';
import logo from '../assets/logo.jpg';
import equipmentImage1 from '../assets/equipment1.jpg';
import equipmentImage2 from '../assets/equipment2.jpg';

const EquipmentSection = () => {
  return (
    <section className="bg-white py-12 md:py-20" id="equipment">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Logo */}
        <img 
          src={logo} 
          alt="Sun Energy Logo" 
          className="h-20 md:h-28 w-auto pb-4 md:pb-8" 
        />
        
        {/* Main Content Container */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-12">
          {/* Left Column Content */}
          <div className="lg:col-span-3">
            {/* Header Content */}
            <div className="mb-8 md:mb-12 pt-4 md:pt-8">
              <h2 className="text-orange-500 font-bold text-xl md:text-2xl mb-3 md:mb-4">
                ASSET INTEGRITY
              </h2>
              <h3 className="text-4xl md:text-6xl lg:text-7xl font-bold text-blue-900 leading-tight">
                Advanced<br />Equipment
              </h3>
            </div>
            
            {/* Left Image */}
            <div className="h-[250px] sm:h-[300px] md:h-[400px] rounded-xl md:rounded-2xl overflow-hidden">
              <img
                src={equipmentImage1}
                alt="Manufacturing Equipment"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column Content */}
          <div className="lg:col-span-2">
            {/* Text Content */}
            <div className="mb-8 md:mb-12 pt-4 md:pt-8">
              <h4 className="text-xl md:text-2xl font-bold text-blue-900 mb-4 md:mb-6">
                Future Proof Installation
              </h4>
              <div className="space-y-3 md:space-y-4 text-gray-700 text-base md:text-xl">
                <p>
                  We installed latest Stringer machines using <span className="font-semibold">0.26mm round ribbons</span> to maximise cell bus bars for more efficient energy capture.
                </p>
                <p>
                  Laminators uses hot oil for consistent temperature on heating surface
                </p>
              </div>
            </div>

            {/* Right Image */}
            <div className="h-[250px] sm:h-[300px] md:h-[400px] rounded-xl md:rounded-2xl overflow-hidden">
              <img
                src={equipmentImage2}
                alt="Solar Panel Assembly"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EquipmentSection;